module.exports = __webpack_public_path__ + "static/img/home_pic1.6d6c681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home2/home_pic1.png
// module id = FnVb
// module chunks = 1